import { ParameterType } from '@/study-search/enums';

import { DegreeTypeFilterOptionValue } from '@studyportals/search-filters';
import { FilterDefinition } from '../FilterDefinition';
import { FilterOptionInformation } from '@studyportals/search-filters';

class MastersDegreeTypeFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.DEGREE_TYPE,
			[
				new FilterOptionInformation(
					'M.Sc. Master of Science',
					DegreeTypeFilterOptionValue.MSC,
					'msc',
					'M.Sc. Master of Science',
					'M.Sc.',
					'M.Scs'
				),
				new FilterOptionInformation(
					'M.A. Master of Arts',
					DegreeTypeFilterOptionValue.MA,
					'ma',
					'M.A. Master of Arts',
					'M.A.',
					'M.As'
				),
				new FilterOptionInformation(
					'M.B.A. Master of Business Administration',
					DegreeTypeFilterOptionValue.MBA,
					'mba',
					'M.B.A. Master of Business Administration',
					'M.B.A.',
					'M.B.As'
				),
				new FilterOptionInformation(
					'LL.M. Master of Laws',
					DegreeTypeFilterOptionValue.LLM,
					'llm',
					'LL.M. Master of Laws',
					'LL.M.',
					'LL.Ms'
				),
				new FilterOptionInformation(
					'M.Phil. Master of Philosophy',
					DegreeTypeFilterOptionValue.MPHIL,
					'mphil',
					'M.Phil. Master of Philosophy',
					'M.Phil.',
					'M.Phils'
				),
				new FilterOptionInformation(
					'M.Litt. Master of Letters',
					DegreeTypeFilterOptionValue.MLITT,
					'',
					'',
					'M.Litt.',
					'M.Litts'
				),
				new FilterOptionInformation(
					'M.Res. Master of Research',
					DegreeTypeFilterOptionValue.MRES,
					'',
					'',
					'M.Res.',
					"M.Res'"
				),
				new FilterOptionInformation(
					'M.Ed. Master of Education',
					DegreeTypeFilterOptionValue.MED,
					'med',
					'M.Ed. Master of Education',
					'M.Ed.',
					'M.Eds'
				),
				new FilterOptionInformation(
					'M.Eng. Master of Engineering',
					DegreeTypeFilterOptionValue.MENG,
					'meng',
					'M.Eng. Master of Engineering',
					'M.Eng.',
					'M.Engs'
				),
				new FilterOptionInformation(
					'Postgraduate Diploma',
					DegreeTypeFilterOptionValue.POSTGRADIP,
					'postgraduate-diploma',
					'Postgraduate Diploma',
					'Postgraduate Diploma',
					'Postgraduate Diplomas'
				),
				new FilterOptionInformation(
					'Postgraduate Certificate',
					DegreeTypeFilterOptionValue.POSTGRADCERT,
					'postgraduate-certificate',
					'Postgraduate Certificate',
					'Postgraduate Certificate',
					'Postgraduate Certificates'
				),
				new FilterOptionInformation(
					'Pre-Master',
					DegreeTypeFilterOptionValue.PREMASTER,
					'pre-master',
					'Pre-Master',
					'Pre-Master',
					'Pre-Masters'
				)
			],
			[
				DegreeTypeFilterOptionValue.MSC,
				DegreeTypeFilterOptionValue.MA,
				DegreeTypeFilterOptionValue.MBA,
				DegreeTypeFilterOptionValue.LLM,
				DegreeTypeFilterOptionValue.MPHIL,
				DegreeTypeFilterOptionValue.MED,
				DegreeTypeFilterOptionValue.MENG,
				DegreeTypeFilterOptionValue.POSTGRADIP,
				DegreeTypeFilterOptionValue.POSTGRADCERT,
				DegreeTypeFilterOptionValue.PREMASTER
			]
		);
	}
}

export default new MastersDegreeTypeFilterDefinition();
